import styled from "styled-components";

export const DislikeTrackBtn = styled.button`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  transition: all 0.1s ease-out;
  padding: 0px;
  &:hover {
    transform: scale(1.25);
  }

  &:active {
    transform: scale(1);
  }

  path {
    transition: fill 0.1s ease-out;
    fill: ${({ dislike }) => (dislike ? "var(--orange-primary)" : "white")};
  }
`;
